// Check if a value is an object
export const isObject = value => value !== null && typeof value === 'object'

export const padZero = val => {
  return ('' + val).padStart(2, '0')
}

export function getColorTag(currentStatus, shouldApplyColor = true) {
  const errorStatuses = ['cancelled', 'danger', 'processing_failure']
  const successStatuses = ['success', 'completed', 'approved']

  if (shouldApplyColor) {
    if (errorStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'text-red-300 font-bold'
    } else if (successStatuses.includes(currentStatus?.toLocaleLowerCase())) {
      return 'text-green-300 font-bold'
    }
  } else {
    return ''
  }
}

export function getFormattedDate(dateString, timeCheck = false, separator = '/') {
  const date = new Date(dateString)

  const locale = navigator.language

  const dateFormat = new Intl.DateTimeFormat(locale)
  const formattedDate = dateFormat.formatToParts(date)

  const dateParts = formattedDate.filter(part => part.type === 'day' || part.type === 'month' || part.type === 'year')

  let formattedDateString = dateParts.map(part => part.value).join(separator)

  if (timeCheck) {
    const timeFormat = new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
    })

    const formattedTime = timeFormat.format(date)
    formattedDateString += ` ${formattedTime}`
  }

  return formattedDateString
}

export const getSelectedRowData = (rowSelection, records) => {
  return rowSelection?.map(selection => records && records[selection?.index]) || []
}

export const getFormattedDateString = date => {
  if (date) {
    const formattedDate = new Date(date)
    return formattedDate.toISOString()
  } else {
    return ''
  }
}

export const convertToLowerCase = content => content?.toLowerCase() ?? content

export const copyToClipboard = value => {
  navigator.clipboard.writeText(value).catch(err => {
    console.error('Failed to copy text:', err)
  })
}

export const capitalizeWords = (str) => {
  return str
    ?.replace(/_/g, ' ') // Replace underscores with spaces
    ?.toLowerCase() // Convert to lowercase
    ?.replace(/\b\w/g, (char) => char?.toUpperCase()); // Capitalize the first letter of each word
};


export const countryCodes = {
  MEXICO: 'MX',
  COLOMBIA: 'CO',
}

export const showOrderTypeFeature = (countryCode) => {
  const allowedMarkets = [
    countryCodes.COLOMBIA
  ];
  const isOrderTypeEnabled = allowedMarkets.includes(countryCode);
  
  return isOrderTypeEnabled;
};
